// bloomsy-ai-assistant.js

// Expose helper so you can open panel from theme if needed
window.BloomsyOpenAIWidget = function (source) {
  const panel = document.getElementById("bai-panel");
  const bubble = document.getElementById("bai-bubble");
  const body = document.getElementById("bai-body");
  if (!panel || !bubble || !body) return;

  panel.style.display = "flex";

  const intro = document.createElement("div");
  intro.className = "bai-msg bai-msg-ai";
  intro.innerHTML = `<span>I’ve opened with context from this ${
    source === "product" ? "product" : "collection"
  }. Tell me who you’re gifting for and your budget?</span>`;
  body.appendChild(intro);
  body.scrollTop = body.scrollHeight;
};

(function () {
  const cfg = window.BLOOMSY_AI_CONFIG || {};
  const root = document.getElementById("bloomsy-ai-assistant-root");
  if (!root) return;

  const isMobile = /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

  // Normalised config (supports old + new names just in case)
  const chatEndpoint =
    (cfg.api && cfg.api.chatEndpoint) ||
    cfg.apiEndpoint ||
    "/api/ai/ai-assistant.php";

  const productsApi =
    (cfg.api && cfg.api.products) || cfg.productsApi || "/api/products";

  const citiesApi =
    (cfg.api && cfg.api.cities) || cfg.citiesApi || "/api/cities";

  const occasionsApi =
    (cfg.api && cfg.api.occasions) || cfg.occasionsApi || "/api/occasions";

  let products = [];
  let cities = [];
  let occasions = [];

  // Load product / city / occasion context
  async function loadContext() {
    try {
      const [prodRes, cityRes, occRes] = await Promise.all([
        fetch(productsApi).catch(() => null),
        fetch(citiesApi).catch(() => null),
        fetch(occasionsApi).catch(() => null),
      ]);

      if (prodRes && prodRes.ok) {
        products = (await prodRes.json()) || [];
      }

      if (cityRes && cityRes.ok) {
        const data = await cityRes.json();
        cities = data.cities || data || [];
      }

      if (occRes && occRes.ok) {
        const data = await occRes.json();
        occasions = data.occasions || data || [];
      }
    } catch (e) {
      console.warn("Bloomsy AI: Failed to load context", e);
    }
  }

  loadContext();

  // ---------- UI skeleton ----------
  root.innerHTML = `
    <div class="bai-panel" id="bai-panel">
      <div class="bai-panel-header">
        🌸 Ask Bloomsy AI for gift ideas
        <button class="bai-close-btn" id="bai-close-btn">✕</button>
    </div>
      <div class="bai-panel-body" id="bai-body">
        <div class="bai-msg bai-msg-ai">
          <span>Hi! Tell me who you’re gifting for, the occasion and budget. I’ll suggest some bouquets and gifts from Bloomsy 💐</span>
        </div>
      </div>
      <div class="bai-panel-footer">
        <input type="text" id="bai-input" class="bai-input" placeholder="Ask about gifts, flowers, cakes..." />
        <button class="bai-mic-btn" id="bai-mic-btn">🎤</button>
        <button class="bai-send-btn" id="bai-send-btn">➤</button>
      </div>
    </div>
    <div class="bai-bubble" id="bai-bubble">💬</div>
  `;

  const panel = document.getElementById("bai-panel");
  const bubble = document.getElementById("bai-bubble");
  const body = document.getElementById("bai-body");
  const input = document.getElementById("bai-input");
  const sendBtn = document.getElementById("bai-send-btn");
  const micBtn = document.getElementById("bai-mic-btn");

  // Toggle panel
  bubble.addEventListener("click", () => {
    panel.style.display = panel.style.display === "flex" ? "none" : "flex";
  });

  //Bubble close button
    const closeBtn = document.getElementById("bai-close-btn");

    closeBtn.addEventListener("click", () => {
    panel.style.display = "none";
    document.body.style.transform = "none"; // if zoom fix was applied
    document.documentElement.style.transform = "none";
    });

  // ---------- Message helpers ----------
  function appendMessage(text, who, productsList) {
    const div = document.createElement("div");
    div.className =
      "bai-msg " + (who === "user" ? "bai-msg-user" : "bai-msg-ai");
    div.innerHTML = `<span>${text}</span>`;
    body.appendChild(div);

    if (productsList && productsList.length) {
      // Wrapper: label + pills
      const wrapper = document.createElement("div");
      wrapper.className = "bai-product-list";

      const label = document.createElement("div");
      label.className = "bai-product-list-label";
      label.textContent = "Suggested from Bloomsy:";
      wrapper.appendChild(label);

      productsList.forEach((p) => {
        if (!p || !p.name) return;
        const a = document.createElement("a");
        a.className = "bai-product-pill";
        a.href = p.url || "#";

        if (isMobile) {
          a.target = "_self";
        } else {
          a.target = "_blank";
          a.rel = "noopener";
        }

        const priceText =
          typeof p.price !== "undefined" && p.price !== null
            ? ` — ₹${p.price}`
            : "";
        a.textContent = `${p.name}${priceText}`;
        wrapper.appendChild(a);
      });

      body.appendChild(wrapper);
    }

    body.scrollTop = body.scrollHeight;
  }

  // ---------- Send to backend ----------
  async function sendMessage(msg) {
    if (!msg || !msg.trim()) return;
    const text = msg.trim();

    // show user message
    appendMessage(text, "user");
    input.value = "";

    // show thinking bubble
    const thinkingDiv = document.createElement("div");
    thinkingDiv.className = "bai-msg bai-msg-ai bai-thinking";
    thinkingDiv.innerHTML = `<span>Thinking…</span>`;
    body.appendChild(thinkingDiv);
    body.scrollTop = body.scrollHeight;

    try {
      const res = await fetch(chatEndpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          message: text,
          context: {
            products,
            cities,
            occasions,
            page: cfg.page || null,
            product: (cfg.context && cfg.context.product) || null,
            collection: (cfg.context && cfg.context.collection) || null,
            cart: (cfg.context && cfg.context.cart) || null,
          },
        }),
      });

      let data = null;
      try {
        data = await res.json();
      } catch (e) {
        console.error("Bloomsy AI: invalid JSON response", e);
      }

      // remove thinking message
      if (thinkingDiv.parentNode) {
        thinkingDiv.parentNode.removeChild(thinkingDiv);
      }

      if (!data) {
        appendMessage(
          "Oops, I couldn’t read the AI response. Please try again.",
          "ai"
        );
        return;
      }

      appendMessage(
        data.message || "Sorry, I could not understand that.",
        "ai",
        data.products || []
      );
    } catch (e) {
      console.error("Bloomsy AI error:", e);
      if (thinkingDiv.parentNode) {
        thinkingDiv.parentNode.removeChild(thinkingDiv);
      }
      appendMessage(
        "Oops, something went wrong while talking to Bloomsy AI. Please try again.",
        "ai"
      );
    }
  }

  // Click send
  sendBtn.addEventListener("click", () => {
    sendMessage(input.value);
  });

  // Press Enter
  input.addEventListener("keydown", (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      sendMessage(input.value);
    }
  });

  // ---------- Voice (speech → text) ----------
  let recognition;
  if ("webkitSpeechRecognition" in window || "SpeechRecognition" in window) {
    const SR = window.SpeechRecognition || window.webkitSpeechRecognition;
    recognition = new SR();
    recognition.lang = "en-IN";
    recognition.continuous = false;
    recognition.interimResults = false;

    micBtn.addEventListener("click", () => {
      recognition.start();
    });

    recognition.onresult = (event) => {
      const transcript = event.results[0][0].transcript;
      input.value = transcript;
      sendMessage(transcript);
    };
  } else {
    micBtn.style.display = "none";
  }

  // ---------- Voice (text → speech) ----------
  function speakText(text) {
    if (!("speechSynthesis" in window)) return;
    const utter = new SpeechSynthesisUtterance(text);
    utter.lang = "en-IN";
    window.speechSynthesis.speak(utter);
  }
})();
